import * as React from 'react';
import { useAppSelector } from '../../hooks';
import { EntityContactRole, EntityUserRole, ReportAccessEnum } from '../../redux/ContactSlice';
import { selectedEntity } from '../../redux/EntitySlice';
import { AdminUserRoleEnum, EntityAuthorization, UserRoleEnum, selectAdminUserRole, selectUserEntityAuthorizations, selectUserRole } from '../../redux/UserSlice';
import utilityHelper from '../../utils/utilityHelper';


const CanShowGivenAdminUserRole = (props: {
    children: React.ReactNode; permittedRoles: AdminUserRoleEnum | Array<AdminUserRoleEnum>
}) => {
   
    const adminUserRoleSelector: AdminUserRoleEnum | null  = useAppSelector(selectAdminUserRole);

    const [canShowChildren, setCanShowChildren] = React.useState<boolean>(false);

    React.useEffect(() => {

        let shouldEnable: boolean = false;

        if (adminUserRoleSelector != null) {
            if (Array.isArray(props.permittedRoles)) {
                if (props.permittedRoles.some((item: AdminUserRoleEnum) => item == adminUserRoleSelector) == true) {
                    shouldEnable = true;
                }
            } else {
                if (adminUserRoleSelector == props.permittedRoles) {
                    shouldEnable = true;
                }
            }
        }

        setCanShowChildren(shouldEnable);

    }, [adminUserRoleSelector, props.permittedRoles])

    return (

        <React.Fragment>
            {
                canShowChildren == true ?
                    (
                        props.children
                    )

                    : (<></>)
            }
        </React.Fragment>
    );

}

export default CanShowGivenAdminUserRole;